/**
 * Hook server-state Dashboard (US-AE.F9 dead-feature fix · @UC9099) — bọc TanStack Query.
 * useDashboard(): KPI + queues + recent activity THẬT. READ-ONLY. retry:false.
 */
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys.js";
import { fetchDashboard, fetchQueueSummary } from "./api.js";

export function useDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard.overview(),
    queryFn: fetchDashboard,
    retry: false,
  });
}

/**
 * Đếm queue (badge Topbar/Sidebar). Poll nhẹ mỗi 60s để badge cập nhật. retry:false; lỗi → data
 * undefined (consumer coi như chưa có badge, KHÔNG bịa số).
 */
const QUEUE_POLL_MS = 60_000;

export function useQueueSummary() {
  return useQuery({
    queryKey: queryKeys.dashboard.queues(),
    queryFn: fetchQueueSummary,
    retry: false,
    refetchInterval: QUEUE_POLL_MS,
  });
}
